export default "__VITE_ASSET__43rdPq_M__"